import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";

import Landing from "./pages/Landing";
import ModelsPage from "./pages/ModelsPage";
import ModelDetailPage from "./pages/ModelDetailPage";
import BookDemoPage from "./pages/BookDemoPage";
import AttachmentsPage from "./pages/AttachmentsPage";
import PartsServicePage from "./pages/PartsServicePage";
import ComparePage from "./pages/ComparePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/models" element={<ModelsPage />} />
            <Route path="/models/:id" element={<ModelDetailPage />} />
            <Route path="/attachments" element={<AttachmentsPage />} />
            <Route path="/parts-service" element={<PartsServicePage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/book-demo" element={<BookDemoPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
